export default {
  // Zuschuss/Pauschale gültig (z.B. Kosten und Finanzierungs ausgeglichen):
  PROCESSOR_STATUS_OK: 1,
  // Es fehlen noch Angaben oder müssen geändert werden:
  PROCESSOR_STATUS_IMPERFECT: 2,
  // Aufgrund der Eingaben wird aus fachlichen Gründen eine Berechnung
  // nicht durchgeführt (bzw. kann keine Pauschale gewährt werden):
  PROCESSOR_STATUS_NOT_APPLICABLE: 3,
};
